class NewsletterFormModule extends HTMLElement {
  connectedCallback() {
    this.scrollToCenterIfMatched()
  }

  scrollToCenterIfMatched() {
    const hash = window.location.hash

    if (hash) {
      try {
        const target = document.querySelector(decodeURIComponent(hash))

        if (!target) return

        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }, 500)
      } catch (e) {
        console.warn('Invalid hash selector:', hash)
      }
    }
  }
}

customElements.define('newsletter-form-module', NewsletterFormModule)
